import React, {useEffect} from 'react';
import styles from './TermsAndConditions.module.css';
import TermsAndConditionsText from '../Components/TermsAndConditions';
import Footer from '../../Desktop/Components/Footer';

const TermsAndConditions = ({onNavigate}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className={styles.communityGuidelines}>
      <div className={styles.body}>
      <h2 className={styles.titleText}>Terms and Conditions<br/> of Use</h2>
      </div>
      <div className={styles.text}>

        <TermsAndConditionsText/>
      </div>
      <Footer onNavigate={onNavigate}/>
    </section>
  );
};

export default TermsAndConditions;
